import { MemberInviteInterface, MemberInviteStatus } from '@swivl-mono/types';
import { Button, ButtonColor, ButtonSize, ButtonVariant, Spinner } from '@swivl-mono/ui';
import { useEffect, useState } from 'react';
import { useMatch, useNavigate } from 'react-router-dom';
import { InviteAcceptComponent } from '../../../Components/InviteAccept/InviteAccept.Component';
import AccountModel from '../../../Models/Account/AccountModel';
import Logo from '../Assets/SwivlLogo.png';
import './InviteView.scss';

export enum InviteViewStates {
  LOADING,
  LOGGED_OUT_ACCOUNT_EXISTS, // The person is not logged in at all, but the user exists. We will pass them to the loggin screen, with a redirect back to this page.
  LOGGED_OUT_NO_ACCOUNT, // The person is not logged in at all, and the user does not exist. We will pass them to the signup screen, with a redirect back to this page.
  LOGGED_IN_DIFFERENT_ACCOUNT, // The person is logged in, but their account isn't this account. We will tell them they need to log out?
  LOGGED_IN_SAME_ACCOUNT, // The person is logged in, and their account is the same as the invite. We will show them the accept screen.
  ACCEPTED, // The person has already accepted the invite. We will show them the already accepted screen.
  REJECTED,
  CANT_FIND_INVITE,
}

export function InviteView() {
  const { account, invites, memberships } = AccountModel.useState();
  const match = useMatch('/invite/:inviteUUID');
  const inviteUUID = match?.params.inviteUUID;
  const navigate = useNavigate();
  const [state, setState] = useState<InviteViewStates>(
    InviteViewStates.LOADING
  );
  useEffect(() => {
    if (inviteUUID) {
      AccountModel.loadInvite(inviteUUID)
    }
  }, [inviteUUID])
  const invite = invites?.find((invite) => invite.uuid === inviteUUID);

  useEffect(() => {
    if (invite && inviteUUID && invites) {
      if (invite.status === MemberInviteStatus.ACCEPTED) {
        setState(InviteViewStates.ACCEPTED);
        return;
      }
      if (invite.status === MemberInviteStatus.DENIED) {
        setState(InviteViewStates.REJECTED);
        return;
      }

      if (invite.account) {
        if (account) {
          if (account.id === invite.account.id) {
            setState(InviteViewStates.LOGGED_IN_SAME_ACCOUNT);
            return;
          } else {
            setState(InviteViewStates.LOGGED_IN_DIFFERENT_ACCOUNT);
            return;
          }
        }
        setState(InviteViewStates.LOGGED_OUT_ACCOUNT_EXISTS);
        return;
      }
      if (account) {
        setState(InviteViewStates.LOGGED_IN_DIFFERENT_ACCOUNT);
        return;
      }
      setState(InviteViewStates.LOGGED_OUT_NO_ACCOUNT);

    } else if (account && invites) {
      setState(InviteViewStates.LOGGED_IN_SAME_ACCOUNT);

    } else if (invites && invites.length === 0) {
      setState(InviteViewStates.CANT_FIND_INVITE);
    }
  }, [invites]);

  if (state === InviteViewStates.LOADING) {
    return <Spinner />;
  }

  if (state === InviteViewStates.LOGGED_OUT_ACCOUNT_EXISTS) {
    return (
      <div className="flex flex-col">
        <img src={Logo} alt="Swivl Logo" className="w-1/2 mx-auto mb-8" />
        <h3 className="mb-4">
          <b>{invite?.org?.name}</b> &nbsp; wants you to join their team.
        </h3>
        <Button
          onClick={() => {
            navigate('/login');
          }}
          size={ButtonSize.LARGE}
          color={ButtonColor.ORANGE}
        >
          Login
        </Button>
      </div>
    );
  }

  // LOGGED_OUT_ACCOUNT_EXISTS, // The person is not logged in at all, but the user exists. We will pass them to the loggin screen, with a redirect back to this page.
  // LOGGED_OUT_NO_ACCOUNT, // The person is not logged in at all, and the user does not exist. We will pass them to the signup screen, with a redirect back to this page.
  // LOGGED_IN_DIFFERENT_ACCOUNT, // The person is logged in, but their account isn't this account. We will tell them they need to log out?
  // LOGGED_IN_SAME_ACCOUNT, // The person is logged in, and their account is the same as the invite. We will show them the accept screen.
  // ACCEPTED, // The person has already accepted the invite. We will show them the already accepted screen.
  // REJECTED,
  // CANT_FIND_INVITE
  if (state === InviteViewStates.LOGGED_OUT_NO_ACCOUNT) {
    return (
      <div className="flex flex-col">
        <img src={Logo} alt="Swivl Logo" className="w-1/2 mx-auto mb-8" />
        <h3 className="mb-4">
          <b>{invite?.org?.name}</b> &nbsp; wants you to join their team.
        </h3>
        <Button
          onClick={() => {
            navigate('/sign-up?invite=' + inviteUUID);
          }}
          size={ButtonSize.LARGE}
          color={ButtonColor.ORANGE}
        >
          Sign Up and Accept
        </Button>
      </div>
    );
  }

  if (state === InviteViewStates.LOGGED_IN_DIFFERENT_ACCOUNT) {
    return (
      <div className="flex flex-col w-1/2 text-center items-center">
        <h3 className=" text-center">Ruh Roh</h3>
        This invite was sent to a different email than is associated with your account.
        Please log out and log in with the correct email to accept this invitation.
        <Button
          color={ButtonColor.ORANGE}
          className="mt-5"
          onClick={() => {
            AccountModel.logOut()
            navigate('/login')
          }}
        >
          Logout
        </Button>
      </div>
    );
  }

  if (state === InviteViewStates.ACCEPTED) {
    return <div className="flex flex-col w-1/2 text-center items-center">

      <h3 className=" text-center">Already Accepted</h3>
      It seems that this invite has already been accepted.
    </div>;
  }
  if (state === InviteViewStates.REJECTED) {
    return <div className="flex flex-col w-1/2 text-center items-center">

      <h3 className=" text-center">Invite Rejected</h3>
      This invite has been rejected.
    </div>;
  }
  if (state === InviteViewStates.CANT_FIND_INVITE) {
    return <div className="flex flex-col w-1/2 text-center items-center">

      <h3 className=" text-center">Ruh Roh</h3>
      We can't find this invite in our system.
    </div>;
  }

  if (state === InviteViewStates.LOGGED_IN_SAME_ACCOUNT) {
    const invitesList: MemberInviteInterface[] = invites ? invites : [invite!]
    const allPending = invitesList.filter((invite) => invite.status === 'pending').length === invitesList.length;
    return <div className="flex flex-col items-center justify-center w-full">
      <img src={Logo} alt="Swivl Logo" className="w-52 mx-auto mb-8" />

      <h1 className="mb-1 font-semibold">Welcome, {account?.firstName}!</h1>
      <p className="text-light mb-3 text-xl">You have pending invites.</p>
      <div className="flex flex-col gap-2 w-3/5 items-center">
        {invitesList.map((invite: MemberInviteInterface) => {
          return <InviteAcceptComponent key={invite.id} invite={invite} />
        })}
      </div>
      {memberships?.length ?
        allPending ? (
          <Button
            className="mt-5"
            onClick={() => {
              navigate('/select-org')
            }}
            variant={ButtonVariant.GHOST}
          >
            Skip
          </Button>
        ) : (
          <Button
            className="mt-5"
            color={ButtonColor.ORANGE}
            onClick={() => {
              navigate('/select-org')
            }}
          >
            Continue
          </Button>
        ) : (
          <Button
            className="mt-5"
            color={ButtonColor.ORANGE}
            onClick={() => {
              AccountModel.logOut()
            }}
          >
            Logout
          </Button>
        )}
    </div>;
  }

  return <div>Unknown State</div>;
}
